export enum LadingPaymentType {
    Cash = 1,
    Receiver = 2,
    Debit = 3
}